module.exports = __webpack_public_path__ + "static/media/women.b896e204.svg";